import type { IDropdownOption } from "@fluentui/react";
import { Dropdown } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { SetStaticFlagData } from "../../../api";
import { StaticFlag, FlagCanId } from "../../../api";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import { useTranslation } from "react-i18next";
import type { TFunction } from "i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type SetStaticFlagNode = Node<InterfaceToRecord<SetStaticFlagData & ExtraNodeData>>;

export default function SetStaticFlag(props: NodeProps<SetStaticFlagNode>): JSX.Element {
    const { t }: { t: TFunction } = useTranslation();

    const [staticFlag, setStaticFlag] = useState(props.data.staticFlag ?? StaticFlag.ONE);
    const [canId, setCanId] = useState(props.data.canId ?? FlagCanId.ALL_ANTENNAS);
    const updateNode = useUpdateNodeData<SetStaticFlagNode>(props.id);

    // Effect to update props data when internal state changes
    useEffect(() => {
        updateNode({ staticFlag, canId });
    }, [staticFlag, canId, updateNode]);

    const dropdownOptionsStaticflag: IDropdownOption[] = Object.values(StaticFlag).map(
        (key, index) => ({
            key,
            text: t(`component.actionConfigNodes.setStaticFlag.staticFlag.${index}`),
        }),
    );

    const dropdownOptionsFlagCanId: IDropdownOption[] = Object.values(FlagCanId).map(
        (key, index) => ({
            key,
            text: t(`component.actionConfigNodes.setFlag.canId.${index}`),
        }),
    );

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <Dropdown
                options={dropdownOptionsStaticflag}
                selectedKey={staticFlag}
                onChange={(_e, option) => setStaticFlag(option?.key as StaticFlag)}
                styles={{ dropdown: { width: 150 } }}
            />
            <Dropdown
                label={t("component.actionConfigNodes.setFlag.canId.label")}
                options={dropdownOptionsFlagCanId}
                selectedKey={canId}
                onChange={(_e, option) => setCanId(option?.key as FlagCanId)}
                styles={{ dropdown: { width: 200 } }}
            />
        </ActionConfigNode>
    );
}
